module.exports = __webpack_public_path__ + "static/media/client_logo_04.630f3159.png";